import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue'
import { showSuccessToast, Locale } from 'vant'
import { getUserLang, setUserLang } from '@/storage/user'
import { useI18n } from 'vue-i18n'
// import customZhCN from '@/locales/zh-CN'
// import customEnUS from '@/locales/en-US'
import enUS from 'vant/es/locale/lang/en-US'
import zhCN from 'vant/es/locale/lang/zh-CN'
interface LanguageOption {
  text: string
  value: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSwitch',
  setup(__props) {

const languageOptions: LanguageOption[] = [
  { text: '中文', value: 'zh-CN' },
  { text: 'English', value: 'en-US' }
]
const { locale } = useI18n() // 新增：获取 vue-i18n 的 locale
const currentLanguage = ref(getUserLang())

onMounted(() => {
  currentLanguage.value = getUserLang()
})

const handleLanguageChange = (value: string) => {
  setUserLang(value)
  showSuccessToast(value === 'zh-CN' ? '语言已切换为中文' : 'Language switched to English')
  document.documentElement.lang = value
  // 更新 vue-i18n 语言
  locale.value = value
  if (value === 'en-US') {
    Locale.use('en-US', enUS)
  } else if (value === 'zh-CN') {
    Locale.use('zh-CN', zhCN)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!

  return (_openBlock(), _createBlock(_component_van_dropdown_menu, null, {
    default: _withCtx(() => [
      _createVNode(_component_van_dropdown_item, {
        modelValue: currentLanguage.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentLanguage).value = $event)),
        options: languageOptions,
        onChange: handleLanguageChange
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})